import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import Welcome from '../views/Welcome.vue'
import UserRole from '../views/user/UserRole.vue'
import Authority from '../views/user/Authority.vue'
import Users from '../views/user/Users.vue'
import MemberInfo from '../views/member/MemberInfo.vue'
import ClassRecord from '../views/member/ClassRecord.vue'
import MemberPremoney from '../views/member/MemberPremoney.vue'
import MapLockDevice from '../views/device/MapLockDevice.vue'
import LockDevice from '../views/device/LockDevice.vue'
import ElectronicFence from '../views/device/MapElectronicFence.vue'
import Distributor from '../views/distributor/Distributor.vue'
import Trip from '../views/trip/Trip.vue'
import SimInfo from '../views/sim/SimInfo.vue'
import MyInfo from '../views/my/MyInfo.vue'
import DataDict from '../views/system/DataDict.vue'
import SplitTest from '../views/distributor/SplitTest.vue'
import SplitRuleManage from '../views/distributor/SplitRuleManage.vue'
import SplitRuleDetailManage from '../views/distributor/SplitRuleDetailManage.vue'
import SplitRecordManage from '../views/distributor/SplitRecordManage.vue'
import SplitDetailManage from '../views/distributor/SplitDetailManage.vue'
import OrderSplitConfigManage from '../views/distributor/OrderSplitConfigManage.vue'
import MerchantPaymentConfigManage from '../views/distributor/MerchantPaymentConfigManage.vue'
import StaffPermission from '../views/staff/StaffPermission.vue'
import Staff from '../views/staff/StaffManage.vue'
import MenuPermission from '../views/permission/MenuPermission.vue'
import ButtonPermission from '../views/permission/ButtonPermission.vue'
import RoleManage from '../views/permission/RoleManage.vue'
import Disclaimer from '../views/system/Disclaimer.vue'
import MyDistributorSetting from '../views/distributor/MyDistributorSetting.vue'
import RepairManage from '../views/repair/RepairManage.vue'
import ProcessedRepairManage from '../views/repair/ProcessedRepairManage.vue'
import DeviceTypeConfig from '../views/device/DeviceTypeConfig.vue'
import UnpaidOrder from '../views/member/UnpaidOrder.vue'

Vue.use(VueRouter)

const routes = [{
		path: '/',
		redirect: '/login',
	},
	{
		path: '/login',
		component: Login,
	},
	{
		path: '/home',
		component: Home,
		redirect: 'welcome',
		children: [
			{
				path: '/welcome',
				component: Welcome,
			},
			{
				path: '/system/role',
				component: UserRole,
			},
			{
				path: '/system/authorities',
				component: Authority,
			},
			{
				path: '/system/user',
				component: Users,
			},
			{
				path: '/memberInfo/list',
				component: MemberInfo,
			},
			{
				path: '/classRecord/findAllRecord',
				component: ClassRecord,
			},
			{
				path: '/member/premoney/list',
				component: MemberPremoney,
			},
			{
				path: '/device/getMapLockDevice',
				component: MapLockDevice,
			},
			{
				path: '/device/getLockDevicePageInfo',
				component: LockDevice,
			},
			{
				path: '/electronicFence/ElectronicFenceList',
				component: ElectronicFence,
			},
			{
				path: '/distributor/list',
				component: Distributor,
			},
			{
				path: '/trip/list',
				component: Trip,
			},
			{
				path: '/sim/list',
				component: SimInfo,
			},
			{
				path: '/my/myInfo',
				component: MyInfo,
			},
			{
				path: '/system/dataDict',
				component: DataDict,
			},
			{
				path: '/distributor/splitTest',
				component: SplitTest,
			},
			{
				path: '/distributor/splitRule',
				component: SplitRuleManage,
			},
			{
				path: '/distributor/splitRuleDetail',
				component: SplitRuleDetailManage,
			},
			{
				path: '/distributor/splitRecord',
				component: SplitRecordManage,
			},
			{
				path: '/distributor/splitDetail',
				component: SplitDetailManage,
			},
			{
				path: '/distributor/orderSplitConfig',
				component: OrderSplitConfigManage,
			},
			{
				path: '/distributor/merchantPaymentConfig',
				component: MerchantPaymentConfigManage,
			},
			{
				path: '/staff/staffPermission',
				component: StaffPermission,
			},
			{
				path: '/staff/staffManage',
				component: Staff,
			},
			{
				path: '/permission/menu',
				component: MenuPermission,
			},
			{
				path: '/permission/button',
				component: ButtonPermission,
			},
			{
				path: '/permission/role',
				component: RoleManage,
			},
			{
				path: '/system/disclaimer',
				component: Disclaimer,
			},
			{
				path: '/distributor/mySetting',
				component: MyDistributorSetting,
			},
			{
				path: '/repair/repairManage',
				component: RepairManage,
			},
			{
				path: '/repair/processedRepairManage',
				component: ProcessedRepairManage,
			},
			{
				path: '/device/typeConfig',
				component: DeviceTypeConfig,
			},
			{
				path: '/member/unpaidOrder',
				component: UnpaidOrder,
			},
		],
	},
]

const router = new VueRouter({
	mode: 'hash',
	routes,
})

router.beforeEach((to, from, next) => {
	//to 代表到哪里去
	//from 表示从哪里跳转
	//next 是一个函数
	//next() 表示放行 next("login") 表示强制跳转
	if (to.path === '/login') return next()
	const tokenStr = window.sessionStorage.getItem('token')
	if (!tokenStr) return next('/login')
	next()
})

export default router
